import React, { useState } from 'react'
import { Button, Modal, Accordion, Spinner } from 'react-bootstrap'
import DNSTable from '../../CustomDomainModal/components/DNSTable'
import { CopyIcon } from '../../CustomDomainModal/constants/utils.js'
import { setUpPassword } from '../../../services/custom-domain.js'
import CustomModal from 'components/CustomModal/CustomModal'
import { useCustomDomain } from 'components/CustomDomainModal/context/CustomDomainProvider'
import { API_ROOT } from 'constants'
import api from 'utils/api'

import '../CustomDomain.css'

const DOC_LINK = 'https://helpdesk.tiiny.host/en/category/custom-domains-141gxwm/'

const Details = ({ onClose, dnsData, refreshProfile, onOpenUpload }) => {
  const [loading, setLoading] = useState(false)
  const [DNSRecordsDiagnostics, setDNSRecordsDiagnostics] = useState(null)
  const [isDiagnosticsError, setIsDiagnosticsError] = useState(false)
  const [activeKey, setActiveKey] = useState('0')

  const isDiagnosticsMismatch = (data) => data && !data?.success && data?.records?.length

  const onSetUpDNS = async (domain) => {
    try {
      setLoading(true)
      await setUpPassword({ domain: domain })
      refreshProfile()
      setLoading(false)
    } catch (error) {
      alert('An error occurred. Please try again or contact support.')
      setLoading(false)
    }
  }

  const onRunDiagnostics = async () => {
    setLoading(true)
    setDNSRecordsDiagnostics(null)
    try {
      const domain = dnsData?.domainRecord?.domain

      const diagnostics = await api.post(`${API_ROOT}/v3/custom-domain/diagnostics`, {
        domain,
        dnsData: { ...dnsData.domainRecord, records: dnsData.records }
      })
      const results = diagnostics?.data

      if (isDiagnosticsMismatch(results)) {
        setDNSRecordsDiagnostics({
          ...results,
          records: results?.records?.filter((r) => !r.matches)
        })
      } else {
        setDNSRecordsDiagnostics({
          ...results,
          records: results?.records
        })
      }

      setActiveKey('1')
      setLoading(false)
    } catch (error) {
      setIsDiagnosticsError(true)
      setDNSRecordsDiagnostics({ error })
      setActiveKey('1')
      setLoading(false)
    }
  }

  const { domainRecord, show } = dnsData
  return (
    <CustomModal
      show={show}
      onHide={onClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      enforceFocus={false}
    >
      <div className="m-4">
        <h3>Connecting your domain</h3>
        <a target="_blank" href={DOC_LINK} rel="noreferrer">
          <Button variant="outline-secondary" size="sm">
            View documentation
          </Button>
        </a>
        <div className="mt-2">
          <Button variant="link" className="p-0" onClick={() => onOpenUpload?.(domainRecord)}>
            Publish existing site / Upload new site
          </Button>
        </div>
        <p className="grey mt-4">
          {DNSRecordsDiagnostics?.success === false
            ? 'The following records in your DNS settings did not match the expected values:'
            : DNSRecordsDiagnostics?.success === true
              ? 'The records in your DNS settings match the expected values:'
              : 'The following DNS records should have been added to your DNS settings:'}
        </p>
        <div className="records">
          <Accordion activeKey={activeKey} onSelect={(k) => setActiveKey(k)} className={''} flush>
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                <span className="font-16">Show DNS records</span>
              </Accordion.Header>
              <Accordion.Body style={{ padding: 0 }}>
                <div className="records-con">
                  <DNSTable
                    data={dnsData}
                    domain={domainRecord?.domain}
                    DNSRecordsDiagnosticsProps={DNSRecordsDiagnostics}
                    loading={loading}
                  />
                </div>
              </Accordion.Body>
            </Accordion.Item>
            {domainRecord?.isEnomDomain && (
              <Accordion.Item eventKey={2}>
                <Accordion.Header>
                  <span className="font-16">Manage DNS Records</span>
                </Accordion.Header>
                <Accordion.Body className="p-3">
                  <p className="mt-2">You can manage your DNS host records with the following login credentials:</p>

                  <div className="manage-dns-con">
                    <div className="flex">
                      <p>
                        <b>Login link</b>:{' '}
                        <a href="https://access.enom.com" target="_blank" rel="noreferrer">
                          https://access.enom.com
                        </a>
                      </p>
                    </div>
                    <div>
                      <b>Domain:</b> <span>{domainRecord?.domain}</span>
                    </div>
                    <div className="flex">
                      <p>
                        <b>Password</b>:{' '}
                        <i>{domainRecord?.dnsPassword ? domainRecord.dnsPassword : 'No password set'}</i>
                      </p>
                      {domainRecord?.dnsPassword && (
                        <CopyIcon text={domainRecord.dnsPassword} customStyle="flex mx-2" />
                      )}
                    </div>

                    {!domainRecord?.dnsPassword && (
                      <div className="flex justify-content-end">
                        <Button variant="outline-secondary" size="sm" onClick={() => onSetUpDNS(domainRecord?.domain)}>
                          {loading ? <Spinner animation="border" size="sm" /> : 'Generate new password'}
                        </Button>
                      </div>
                    )}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            )}
          </Accordion>
        </div>
      </div>
      <Button variant="outline-primary" className="ms-4 me-4 mb-2" onClick={onRunDiagnostics}>
        Analyze Issues
      </Button>
      <Button className="ms-4 me-4 mb-4" onClick={onClose}>
        Done
      </Button>
    </CustomModal>
  )
}

export default Details
